export default class Button {
  static Group() {
    return m('.btn-group', ...arguments);
  }

  static build({
    color = 'default', text = '', icon = '', size = '',
    outline = false, round = false, squared = false, disabled = false,
    block = false, onclick = null, className = [],
  }) {
    // construct attrs
    let attrs = {
      type: 'button',
      className: [
        'btn',
        color && 'btn-' + color,
        round && 'btn-round',
        squared && 'btn-squared',
        outline && 'btn-outline',
        block && 'btn-block',
        size && 'btn-' + size,
        disabled && 'disabled'
      ],
      onclick,
      disabled,
    };

    const children = text;
    attrs.className = _.compact(attrs.className).join(' ');

    // return element
    return m('button', attrs, children);
  }
}
